// SearchPage.js

import React, { useState, useRef, useEffect, useCallback } from 'react';
import Webcam from 'react-webcam';
import {
  Button,
  Spinner,
  IconButton,
  Alert,
  Typography,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from "@material-tailwind/react";
import {
  CameraIcon,
  ArrowUpTrayIcon,
  PlusIcon,
  MinusIcon,
  ClockIcon,
  UserGroupIcon,
  FireIcon,
  HeartIcon,
  XMarkIcon,
  CheckIcon,
  MagnifyingGlassIcon,
  ArrowDownTrayIcon
} from "@heroicons/react/24/outline";
import { generateRecipePdf } from '../utils/generateRecipePdf';
import { useLanguage } from '../contexts/LanguageContext';
import { languages } from '../languages';
import { mcDePageClass } from '../utils/branding';
import ReactSelect from 'react-select';
import RecipeDetail from './RecipeDetail';
import Cooking from './svg/Cooking';
import TetrisGame from './TetrisGame';
import cookingTips, { getRandomCookingTip } from '../cookingTips';
import { getRandomFoodWasteSaving } from '../foodWasteAndFacts';
import { openDB } from 'idb'; // Import voor IndexedDB
import axios from 'axios';
import imageCompression from 'browser-image-compression';
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import { resolveImageUrl } from '../utils/imageUrl';
import { filterHalalIngredients, filterHalalRecipes } from '../utils/halalFilter';



let db; // Variabele voor IndexedDB

const SearchPage = () => {
  const { language } = useLanguage();
  const [isUploading, setIsUploading] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [selectedRecipe, setSelectedRecipe] = useState(null);
  const [isDetailDialogOpen, setIsDetailDialogOpen] = useState(false);
  const [selectedRecipeIndex, setSelectedRecipeIndex] = useState(null);
  const [numberOfPeople, setNumberOfPeople] = useState(1);
  const [timeOfDay, setTimeOfDay] = useState('');
  const [preferredCuisines, setPreferredCuisines] = useState([]);
  const [selectedAllergies, setSelectedAllergies] = useState([]);
  const [displayedRecipes, setDisplayedRecipes] = useState(4);
  const [imageData, setImageData] = useState({});
  const [photoResult, setPhotoResult] = useState('');
  const [recipes, setRecipes] = useState([]);
  const [showTetris, setShowTetris] = useState(false);
  const [currentTip, setCurrentTip] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertColor, setAlertColor] = useState('black');
  const [recipesLoaded, setRecipesLoaded] = useState(false);
  const [showRecipeLoadedDialog, setShowRecipeLoadedDialog] = useState(false);
  const [recipesReady, setRecipesReady] = useState(false);
  const [currentMessage, setCurrentMessage] = useState({ type: '', content: '' });
  const [isCameraActive, setIsCameraActive] = useState(false);
  const [capturedImage, setCapturedImage] = useState(null);
  const [showImagePreview, setShowImagePreview] = useState(false);
  const [hasViewedRecipes, setHasViewedRecipes] = useState(false);
  const [showNewSearchDialog, setShowNewSearchDialog] = useState(false);
  const [selectedIngredients, setSelectedIngredients] = useState([]);
  const [selectedDiet, setSelectedDiet] = useState(null);
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const fileInputRef = useRef(null);
  const webcamRef = useRef(null);
  const [startTime, setStartTime] = useState(null);

  // Map Belgian language codes to french and nederlands for translations
  let translationLanguage = language;
  if (language === 'befr' || language === 'be-fr') {
    translationLanguage = 'french';
  } else if (language === 'benl' || language === 'be-nl') {
    translationLanguage = 'nederlands';
  } else if (language === 'bh-ar' || language === 'bahrain-arabic') {
    translationLanguage = 'arabic';
  } else if (language === 'bh-en' || language === 'bahrain-english') {
    translationLanguage = 'english';
  } else if (language === 'uae-ar' || language === 'uae-arabic') {
    translationLanguage = 'arabic';
  } else if (language === 'uae-en' || language === 'uae-english') {
    translationLanguage = 'english';
  } else if (language === 'sa-ar' || language === 'sa-arabic') {
    translationLanguage = 'arabic';
  } else if (language === 'sa-en' || language === 'sa-english') {
    translationLanguage = 'english';
  } else if (language === 'kw-ar' || language === 'kw-arabic') {
    translationLanguage = 'arabic';
  } else if (language === 'kw-en' || language === 'kw-english') {
    translationLanguage = 'english';
  } else if (language === 'qa-ar' || language === 'qa-arabic') {
    translationLanguage = 'arabic';
  } else if (language === 'qa-en' || language === 'qa-english') {
    translationLanguage = 'english';
  } else if (language === 'om-ar' || language === 'om-arabic') {
    translationLanguage = 'arabic';
  } else if (language === 'om-en' || language === 'om-english') {
    translationLanguage = 'english';
  } else if (language === 'iq-ar' || language === 'iq-arabic') {
    translationLanguage = 'arabic';
  } else if (language === 'iq-en' || language === 'iq-english') {
    translationLanguage = 'english';
  } else if (language === 'jo-ar' || language === 'jo-arabic') {
    translationLanguage = 'arabic';
  } else if (language === 'jo-en' || language === 'jo-english') {
    translationLanguage = 'english';
  } else if (language === 'lb-ar' || language === 'lb-arabic') {
    translationLanguage = 'arabic';
  } else if (language === 'lb-en' || language === 'lb-english') {
    translationLanguage = 'english';
  } else if (language === 'sy-ar' || language === 'sy-arabic') {
    translationLanguage = 'arabic';
  } else if (language === 'sy-en' || language === 'sy-english') {
    translationLanguage = 'english';
  } else if (language === 'ps-ar' || language === 'ps-arabic') {
    translationLanguage = 'arabic';
  } else if (language === 'ps-en' || language === 'ps-english') {
    translationLanguage = 'english';
  } else if (language === 'ye-ar' || language === 'ye-arabic') {
    translationLanguage = 'arabic';
  } else if (language === 'ye-en' || language === 'ye-english') {
    translationLanguage = 'english';
  } else if (language === 'eg-ar' || language === 'eg-arabic') {
    translationLanguage = 'arabic';
  } else if (language === 'eg-en' || language === 'eg-english') {
    translationLanguage = 'english';
  } else if (language === 'pl-pl') {
        translationLanguage = 'polish';
    } else if (language === 'cyprus' || language === 'cy' || language === 'el-cy') {
        translationLanguage = 'greek';
    }

  // Get translations with fallback
  const t = languages[translationLanguage] || languages['english'];
  // Initialiseer IndexedDB
  useEffect(() => {
    const initDB = async () => {

      db = await openDB('RecipeApp', 2, { // Verhoog het versienummer naar 2
        upgrade(db) {
          if (!db.objectStoreNames.contains('favorites')) {
            db.createObjectStore('favorites', { keyPath: 'recipe.name' });
          }
          if (!db.objectStoreNames.contains('temporaryData')) {
            db.createObjectStore('temporaryData');
          }
        },
      });
      console.log('IndexedDB initialized with version 2');
      console.log('Object stores:', db.objectStoreNames);
    };
    initDB();
  }, []);

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    if (userId) {
      axios.get(`/api/user/${userId}/preferences`)
        .then(response => {
          const allergies = response.data.allergies || [];
          if (allergies.length > 0) {
            const preSelected = allergies.map(a => {
              const label = t[a] || a;
              return { value: a, label: label };
            });
            setSelectedAllergies(preSelected);
          }
        })
        .catch(err => console.error('Error loading allergen preferences:', err));
    }
  }, []);

  const dietOptions = [
    { value: 'keto', label: `🥑 ${t.keto}` },
    { value: 'lowCarb', label: `🍖 ${t.lowCarb}` },
    { value: 'vegetarian', label: `🥗 ${t.vegetarian}` },
    { value: 'vegan', label: `🌱 ${t.vegan}` },
    { value: 'paleo', label: `🍗 ${t.paleo}` },
    { value: 'mediterranean', label: `🫒 ${t.mediterraneanDiet}` },
    { value: 'dairyFree', label: `🥛 ${t.dairyFree}` },
    { value: 'glutenFree', label: `🌾 ${t.glutenFree}` },
    { value: 'lowFat', label: `💪 ${t.lowFat}` },
    { value: 'highProtein', label: `🥩 ${t.highProtein}` },
  ];

  const allIngredientOptions = [
    { value: 'chicken', label: `🍗 ${t.chicken}` },
    { value: 'beef', label: `🥩 ${t.beef}` },
    { value: 'pork', label: `🥓 ${t.pork}` },
    { value: 'salmon', label: `🐟 ${t.salmon}` },
    { value: 'shrimp', label: `🦐 ${t.shrimp}` },
    { value: 'eggs', label: `🥚 ${t.eggs}` },
    { value: 'tofu', label: `🧊 ${t.tofu}` },
    { value: 'tuna', label: `🐟 ${t.tuna}` },
    { value: 'potato', label: `🥔 ${t.potato}` },
    { value: 'rice', label: `🍚 ${t.rice}` },
  ];

  // Filter out haram ingredients for Arabic-speaking users
  const ingredientOptions = filterHalalIngredients(allIngredientOptions, language);

  // Controleer bij het laden van de pagina of er opgeslagen recepten zijn
  useEffect(() => {
    const savedRecipes = sessionStorage.getItem('savedRecipes');
    if (savedRecipes) {
      // Toon de dialoog "Nieuwe recepten zoeken?"
      setShowNewSearchDialog(true);
    } else {
      // Stel het dagdeel automatisch in als er geen opgeslagen recepten zijn
      const autoTimeOfDay = determineTimeOfDay();
      setTimeOfDay(autoTimeOfDay);
    }
  }, []);

  useEffect(() => {
    const ingredientParam = searchParams.get('ingredient');
    console.log('URL ingredient parameter:', ingredientParam);

    if (ingredientParam) {
      const option = ingredientOptions.find(opt => opt.value === ingredientParam.toLowerCase());
      console.log('Found ingredient option:', option);

      if (option) {
        console.log('Setting selected ingredients to:', [option]);
        setSelectedIngredients([option]);
      }
    }
  }, [searchParams]);

  const updateUrlParams = useCallback((ingredients) => {
    if (ingredients.length === 0) {
      // Als er geen ingrediënten zijn geselecteerd, verwijder de parameter
      searchParams.delete('ingredient');
      setSearchParams(searchParams);
    } else if (ingredients.length === 1 && ingredients[0].value === searchParams.get('ingredient')) {
      // Als hetzelfde enkele ingredient is geselecteerd, doe niets
      return;
    } else {
      // Voor alle andere gevallen, verwijder de parameter
      navigate('/search', { replace: true });
    }
  }, [searchParams, setSearchParams, navigate]);

  // Log wanneer selectedIngredients verandert
  useEffect(() => {
    console.log('selectedIngredients updated:', selectedIngredients);
  }, [selectedIngredients]);

  const handleIngredientsChange = (newIngredients) => {
    console.log('Ingredients changed to:', newIngredients);
    setSelectedIngredients(newIngredients);
  };

  // Functie om de tijd van de dag te bepalen
  const determineTimeOfDay = () => {
    const currentHour = new Date().getHours();
    if (currentHour >= 6 && currentHour < 10) return 'breakfast';
    if (currentHour >= 10 && currentHour < 12) return 'morningSnack';
    if (currentHour >= 12 && currentHour < 15) return 'lunch';
    if (currentHour >= 15 && currentHour < 18) return 'afternoonSnack';
    if (currentHour >= 18 && currentHour < 21) return 'dinner';
    if (currentHour >= 21 && currentHour < 23) return 'dessert';
    return 'lateNightSnack';
  };

  // Functie om de keuze van de gebruiker in de dialoog af te handelen
  const handleNewSearchChoice = async (choice) => {
    setShowNewSearchDialog(false);
    if (choice === 'yes') {
      // Verwijder de opgeslagen recepten en reset de state
      sessionStorage.removeItem('savedRecipes');
      sessionStorage.removeItem('photoResult');

      // Verwijder imageData uit IndexedDB
      if (db) {
        try {
          const tx = db.transaction('temporaryData', 'readwrite');
          const store = tx.objectStore('temporaryData');
          await store.delete('savedImageData');
          await tx.done;
          console.log('imageData successfully deleted from IndexedDB');
        } catch (error) {
          console.error('Error deleting imageData from IndexedDB:', error);
        }
      }
      // Reset de relevante state
      setRecipes([]);
      setImageData({});
      setRecipesReady(false);
      setRecipesLoaded(false);
      setShowTetris(false);

      // Stel het dagdeel opnieuw in
      const autoTimeOfDay = determineTimeOfDay();
      setTimeOfDay(autoTimeOfDay);
    } else if (choice === 'no') {
      // Haal de recepten uit sessionStorage
      const savedRecipes = JSON.parse(sessionStorage.getItem('savedRecipes'));
      const savedPhotoResult = sessionStorage.getItem('photoResult');

      // Haal imageData op uit IndexedDB
      let savedImageData = {};
      if (db) {
        try {
          const tx = db.transaction('temporaryData', 'readonly');
          const store = tx.objectStore('temporaryData');
          savedImageData = await store.get('savedImageData');
          await tx.done;
          console.log('Retrieved imageData from IndexedDB:', savedImageData);
        } catch (error) {
          console.error('Error retrieving imageData from IndexedDB:', error);
        }
      } else {
        console.error('IndexedDB is not initialized');
      }

      // Zet de data in de state
      setRecipes(savedRecipes);
      setImageData(savedImageData || {});
      setPhotoResult(savedPhotoResult);

      // **Update displayedRecipes naar het totale aantal recepten**
      setDisplayedRecipes(savedRecipes.length);

      setRecipesReady(true);
      setRecipesLoaded(true);
    }
  };





  // Sla recepten en relevante state op in sessionStorage bij het verlaten van de pagina
  useEffect(() => {
    const handleBeforeUnload = async () => {
      if (recipes.length > 0) {
        sessionStorage.setItem('savedRecipes', JSON.stringify(recipes));
        sessionStorage.setItem('photoResult', photoResult);

        // Controleer de inhoud van imageData
        console.log('Saving imageData to IndexedDB:', imageData);

        // Sla imageData op in IndexedDB
        if (db) {
          try {
            const tx = db.transaction('temporaryData', 'readwrite');
            const store = tx.objectStore('temporaryData');
            await store.put(imageData, 'savedImageData');
            await tx.done;
            console.log('imageData successfully saved to IndexedDB');
          } catch (error) {
            console.error('Error saving imageData to IndexedDB:', error);
          }
        } else {
          console.error('IndexedDB is not initialized');
        }
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      // Sla ook op bij unmount
      handleBeforeUnload();
    };
  }, [recipes, imageData, photoResult, db]);


  // Functie om een recept op te slaan in favorieten
  const handleFavorite = async (event, recipe, index) => {
    event.stopPropagation(); // Zorg ervoor dat de klik niet het receptdetail opent
    const userId = localStorage.getItem('userId');
    try {
      const recipeData = {
        userId: userId,
        name: recipe.name,
        intro: recipe.intro,
        ingredients: recipe.ingredients,
        instructions: recipe.instructions,
        allergens: recipe.allergens || [],
        nutritions: recipe.nutritions,
        calories_per_serving: recipe.calories_per_serving,
        cooking_time: recipe.cooking_time,
        servings: recipe.servings,
        imageData: imageData[index] || '',
        language: language,
      };

      const response = await axios.post('/api/save-recipe', recipeData);

      if (response.data.success) {
        if (response.data.recipeId) {
          const updatedRecipes = [...recipes];
          updatedRecipes[index] = { ...updatedRecipes[index], recipe_id: response.data.recipeId };
          setRecipes(updatedRecipes);
        }
        setAlertMessage(t.recipeSaved.replace('{recipeName}', recipe.name));
        setAlertColor('green');
      } else {
        throw new Error(response.data.error || t.errorSavingRecipe || 'Failed to save recipe.');
      }

    } catch (error) {
      console.error('Fout bij opslaan in de API:', error);

      if (error.response && error.response.status === 409) {
        // Recept is al opgeslagen, toon specifieke foutmelding
        setAlertMessage(t.recipeAlreadySaved || 'Recipe is already saved.');
        setAlertColor('black');
      } else {
        // Algemeen foutbericht bij het opslaan
        setAlertMessage(t.errorSavingRecipe || 'Error saving recipe. Please try again.');
        setAlertColor('red');
      }
    }

    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 3000);
  };

  const handleDownloadPdf = async (event, recipe, index) => {
    event.stopPropagation();
    try {
      await generateRecipePdf(recipe, t, imageData[index]);
      setAlertMessage(t.pdfDownloaded || 'PDF downloaded!');
      setAlertColor('green');
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
    } catch (error) {
      console.error('Error generating PDF:', error);
      setAlertMessage(t.errorDownloadingPdf || 'Error downloading PDF.');
      setAlertColor('red');
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 3000);
    }
  };

  // Functie om een willekeurige kooktip te krijgen
  const getRandomTip = () => {
    return getRandomCookingTip(language);
  };

  // Gebruik useEffect om tips te tonen tijdens het uploaden
  useEffect(() => {
    if (isUploading) {
      setCurrentTip(getRandomTip());
      setCurrentMessage({ type: 'saving', content: getRandomFoodWasteSaving(language) });

      const tipInterval = setInterval(() => {
        setCurrentTip(getRandomTip());
      }, 12500);
      return () => clearInterval(tipInterval);
    }
  }, [isUploading, language]);

  // Functies voor camera en foto uploaden
  const startCamera = () => {
    setIsCameraActive(true);
  };

  const capturePhoto = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc) {
      setCapturedImage(imageSrc);
      setShowImagePreview(true);
      setIsCameraActive(false);
    }
  }, [webcamRef]);

  const handleApproveImage = () => {
    if (capturedImage) {
      fetch(capturedImage)
        .then(res => res.blob())
        .then(blob => {
          sendDataToWebhook(blob, 'camera');
        });
    }
    setShowImagePreview(false);
    setCapturedImage(null);
  };

  const handleRejectImage = () => {
    setShowImagePreview(false);
    setCapturedImage(null);
    startCamera();
  };

  const closeCamera = () => {
    setIsCameraActive(false);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      sendDataToWebhook(file, 'upload');
    }
  };


  const sendDataToWebhook = async (data, source, isLoadMore = false) => {
    // Validate that there's a photo when filters are set but no photo is present
    if (!isLoadMore && !data) {
      // Check if any filters are set
      const hasFilters = numberOfPeople > 1 ||
        timeOfDay !== '' ||
        preferredCuisines.length > 0 ||
        selectedAllergies.length > 0 ||
        selectedIngredients.length > 0 ||
        selectedDiet !== null;

      if (hasFilters) {
        // Show error message
        setAlertMessage(t.pleaseAddPhotoFirst || 'Please add a photo first or take a photo');
        setAlertColor('red');
        setShowAlert(true);
        setTimeout(() => setShowAlert(false), 4000);
        return;
      }
    }

    if (!isLoadMore) {
      setStartTime(Date.now());
      setIsUploading(true);
      setRecipes([]);
      setImageData({});
    }

    let jsonData;
    const cuisinesStr = preferredCuisines.map(cuisine => cuisine.value).join(',');
    const allergiesStr = selectedAllergies.map(allergy => allergy.value).join(',');
    const ingredientsStr = selectedIngredients.map(ingredient => ingredient.value).join(',');
    const dietStr = selectedDiet ? selectedDiet.value : '';

    try {
      if (isLoadMore) {
        const response = await axios.post('/api/ai/recipes/more', {
          photo_result: photoResult,
          existingRecipeNames: recipes.map(recipe => recipe.name),
          language,
          numberOfPeople,
          preferredCuisines: cuisinesStr,
          selectedAllergies: allergiesStr,
          selectedIngredients: ingredientsStr,
          selectedDiet: dietStr,
        }, { timeout: 120000 });
        jsonData = response.data;
      } else {
        const formData = new FormData();
        const options = { maxSizeMB: 1, maxWidthOrHeight: 1920, useWebWorker: true };
        try {
          const compressedFile = await imageCompression(data, options);
          formData.append('image', compressedFile, compressedFile.name || 'image.jpg');
        } catch (error) {
          console.error("Error compressing image:", error);
          alert(t.errorCompressingImage);
          setIsUploading(false);
          return;
        }
        formData.append('language', language);
        formData.append('numberOfPeople', numberOfPeople);
        formData.append('timeOfDay', timeOfDay);
        formData.append('preferredCuisines', cuisinesStr);
        formData.append('selectedAllergies', allergiesStr);
        formData.append('selectedIngredients', ingredientsStr);
        formData.append('selectedDiet', dietStr);

        const response = await axios.post('/api/ai/recipes', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          timeout: 120000,
        });
        jsonData = response.data;
      }

      console.log(jsonData);

      if (isLoadMore) {
        setRecipes(prevRecipes => [...prevRecipes, ...jsonData.recipes]);
      } else {
        const noFood = jsonData.food_detected === false
          || jsonData.photo_result === 'NO_FOOD_DETECTED'
          || (!jsonData.recipes || jsonData.recipes.length === 0);

        if (noFood) {
          setAlertMessage(t.noFoodDetected);
          setAlertColor('red');
          setShowAlert(true);
          setTimeout(() => setShowAlert(false), 6000);
          setIsUploading(false);
          setRecipesLoaded(false);
          return;
        }

        setRecipes(jsonData.recipes || []);
        setPhotoResult(jsonData.photo_result);
        setRecipesLoaded(true);
        if (showTetris) {
          setShowRecipeLoadedDialog(true);
        } else {
          setRecipesReady(true);
        }
      }

      setDisplayedRecipes(isLoadMore ? recipes.length + jsonData.recipes.length : 4);

      const existingRecipesCount = isLoadMore ? recipes.length : 0;
      const newImageData = { ...imageData };
      for (const [key, value] of Object.entries(jsonData.images || {})) {
        const imageIndex = parseInt(key.replace('image', '').replace('_url', '')) - 1;
        const adjustedIndex = existingRecipesCount + imageIndex;
        newImageData[adjustedIndex] = value;
      }
      setImageData(newImageData);
    } catch (error) {
      console.error("Error fetching data:", error);
      alert(t.errorFetchingData);
    } finally {
      if (!isLoadMore) {
        setIsUploading(false);
      }
    }
  };

  const loadMoreRecipes = async () => {
    if (!photoResult) {
      console.error("No photo result available for load more");
      return;
    }
    setIsLoadingMore(true);
    await sendDataToWebhook(null, 'loadMore', true);
    setIsLoadingMore(false);
  };

  // ReactSelect opties
  const cuisineOptions = [
    { value: 'italian', label: `🇮🇹 ${t.italian}` },
    { value: 'chinese', label: `🇨🇳 ${t.chinese}` },
    { value: 'indian', label: `🇮🇳 ${t.indian}` },
    { value: 'mexican', label: `🇲🇽 ${t.mexican}` },
    { value: 'french', label: `🇫🇷 ${t.french}` },
    { value: 'thai', label: `🇹🇭 ${t.thai}` },
    { value: 'japanese', label: `🇯🇵 ${t.japanese}` },
    { value: 'mediterranean', label: `🌊 ${t.mediterranean}` },
    { value: 'spanish', label: `🇪🇸 ${t.spanish}` },
    { value: 'greek', label: `🇬🇷 ${t.greek}` },
    { value: 'vietnamese', label: `🇻🇳 ${t.vietnamese}` },
    { value: 'american', label: `🇺🇸 ${t.american}` },
    { value: 'turkish', label: `🇹🇷 ${t.turkish}` },
    { value: 'korean', label: `🇰🇷 ${t.korean}` },
    { value: 'moroccan', label: `🇲🇦 ${t.moroccan}` },
    { value: 'persian', label: `🇮🇷 ${t.persian}` },
  ];

  const allergyOptions = [
    { value: 'gluten', label: `🌾 ${t.gluten}` },
    { value: 'nuts', label: `🥜 ${t.nuts}` },
    { value: 'lactose', label: `🥛 ${t.lactose}` },
    { value: 'soy', label: `🫘 ${t.soy}` },
    { value: 'shellfish', label: `🦐 ${t.shellfish}` },
    { value: 'fish', label: `🐟 ${t.fish}` },
    { value: 'eggs', label: `🥚 ${t.eggs}` },
    { value: 'peanuts', label: `🥜 ${t.peanuts}` },
    { value: 'sesame', label: `🫘 ${t.sesame}` },
    { value: 'sulphites', label: `🧪 ${t.sulphites}` },
    { value: 'mustard', label: `🌭 ${t.mustard}` },
    { value: 'celery', label: `🥬 ${t.celery}` },
    { value: 'lupin', label: `🌸 ${t.lupin}` },
    { value: 'molluscs', label: `🐚 ${t.molluscs}` },
  ];

  const timeOfDayOptions = [
    { value: "breakfast", label: t.breakfast },
    { value: "morningSnack", label: t.morningSnack },
    { value: "lunch", label: t.lunch },
    { value: "afternoonSnack", label: t.afternoonSnack },
    { value: "dinner", label: t.dinner },
    { value: "dessert", label: t.dessert },
    { value: "lateNightSnack", label: t.lateNightSnack },
  ];

  // Functies voor Tetris en tips
  const startTetris = () => {
    setShowTetris(true);
  };

  const backToWaitingScreen = () => {
    setShowTetris(false);
    // setShowWaitingScreen(true);
  };

  useEffect(() => {
    if (recipesLoaded && showTetris) {
      setShowRecipeLoadedDialog(true);
    }
  }, [recipesLoaded, showTetris]);

  const handleContinueTetris = () => {
    setShowRecipeLoadedDialog(false);
    setRecipesReady(true);

  };

  const handleViewRecipes = () => {
    setShowRecipeLoadedDialog(false);
    setShowTetris(false);
    setRecipesReady(true);
    setHasViewedRecipes(true);
  };

  const toggleView = () => {
    setShowTetris(prev => !prev);
    setHasViewedRecipes(true);
  };

  return (
    <div className={`flex flex-col justify-between px-2 h-full mb-16 ${mcDePageClass(language)}`}>
      {/* Nieuwe recepten zoeken dialoog */}
      {showNewSearchDialog && (
        <Dialog size="xl" open={showNewSearchDialog} handler={() => { }}>
          <DialogHeader>{t.newSearchQuestion}</DialogHeader>
          <DialogBody>{t.newSearchPrompt}</DialogBody>
          <DialogFooter className="flex justify-between">
            <Button variant="outlined" size="sm" color="blue-gray" className='flex items-center justify-center gap-2' onClick={() => handleNewSearchChoice('yes')}>
              <MagnifyingGlassIcon className='w-4 h-4' />
              {t.searchNewRecipes}
            </Button>
            <Button className="shadow-none" size="sm" color="green" onClick={() => handleNewSearchChoice('no')}>
              {t.seeOldRecipes}
            </Button>

          </DialogFooter>
        </Dialog>
      )}

      {/* Toon invoervelden en uploadknoppen alleen als er geen recepten zijn of recipesReady false is */}
      {(!recipesReady || recipes.length === 0) && (
        <>
          <h1 className="text-2xl text-center font-semibold ">{t.search}</h1>
          <div>
            <div className="flex flex-row items-center justify-center gap-16 my-6">
              <div className='flex items-center flex-col gap-2 text-center' >
                <Button variant="outlined" color="blue-gray" className="flex items-center gap-2 p-4 rounded-full border-none bg-blue-gray-50" onClick={() => fileInputRef.current.click()}>
                  <ArrowUpTrayIcon className="h-10 w-10" />
                </Button>
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileUpload}
                  accept="image/*"
                  style={{ display: 'none' }}
                />
                <span>{t.uploadPhoto}</span>
              </div>
              <div className='flex items-center flex-col gap-2 text-center'>
                <Button color="green"
                  variant="outlined"
                  className="flex items-center gap-2 p-4 rounded-full border-none bg-green-50"
                  onClick={startCamera}>
                  <CameraIcon className="h-10 w-10" />
                </Button>
                <span>{t.takePhoto}</span>
              </div>
            </div>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 my-4">
              <Typography variant='small' className="text-blue-700 text-center block">
                {t.photoTip || 'For best results, upload a clear photo of your ingredients or a dish.'}
              </Typography>
            </div>

            <hr className='my-5'></hr>

            <div className="flex items-center justify-between mb-2">
              <Typography variant='h6' className="mr-4">{t.numberOfPeople}:</Typography>
              <div className='flex gap-2 items-center'>
                <IconButton
                  variant="text"
                  color="green"
                  onClick={() => setNumberOfPeople(prev => Math.max(prev - 1, 1))}
                  className="mr-2 "
                >
                  <MinusIcon className="h-5 w-5" />
                </IconButton>
                <span>{numberOfPeople}</span>
                <IconButton
                  variant="text"
                  color="green"
                  onClick={() => setNumberOfPeople(prev => prev + 1)}
                  className="ml-2"
                >
                  <PlusIcon className="h-5 w-5" />
                </IconButton>
              </div>
            </div>
            <div className="mb-4">
              <Typography variant='h6' className="block mb-2">{t.timeOfDay}:</Typography>
              <ReactSelect
                options={timeOfDayOptions}
                value={timeOfDayOptions.find(option => option.value === timeOfDay)}
                onChange={(selectedOption) => setTimeOfDay(selectedOption.value)}
                placeholder={t.selectTimeOfDay}
                className="basic-select"
                classNamePrefix="select"
              />
            </div>
            <div className="mb-4">
              <Typography variant='h6' className="block mb-2">{t.preferredCuisine}:</Typography>
              <ReactSelect
                isMulti
                name="preferredCuisines"
                options={cuisineOptions}
                className="basic-multi-select"
                classNamePrefix="select"
                value={preferredCuisines}
                onChange={setPreferredCuisines}
                placeholder={t.selectCuisine}
              />
            </div>
            <div className="mb-4">
              <Typography variant='h6' className="block mb-2">{t.allergies}:</Typography>
              <ReactSelect
                isMulti
                name="allergies"
                options={allergyOptions}
                className="basic-multi-select"
                classNamePrefix="select"
                value={selectedAllergies}
                onChange={setSelectedAllergies}
                placeholder={t.selectAllergies}
              />
            </div>
            <div className="mb-4">
              <Typography variant='h6' className="block mb-2">{t.ingredients}:</Typography>
              <ReactSelect
                isMulti
                name="ingredients"
                options={ingredientOptions}
                className="basic-multi-select"
                classNamePrefix="select"
                value={selectedIngredients}
                onChange={setSelectedIngredients}
                placeholder={t.selectIngredients}
              />
            </div>

            <div className="mb-4">
              <Typography variant='h6' className="block mb-2">{t.diet}:</Typography>
              <ReactSelect
                name="diet"
                options={dietOptions}
                className="basic-select"
                classNamePrefix="select"
                value={selectedDiet}
                onChange={setSelectedDiet}
                placeholder={t.selectDiet}
                isClearable
              />
            </div>
          </div>
        </>
      )}

      {/* Toon de recepten als recipesReady true is */}
      {recipesReady && !showTetris && (
        <>
          <div className="mt-2 mb-2 flex justify-center">
            <Button
              variant='outlined'
              size='sm'
              color={showTetris ? "green" : "blue-gray"}
              onClick={toggleView}
              className={`${showTetris ? "bg-green-50" : "bg-blue-gray-50"} flex items-center gap-2 m-auto`}
            >
              {showTetris ?
                (<>
                  {t.viewRecipes}
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
                  </svg>
                </>)
                : (
                  <>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                      <path strokeLinecap="round" strokeLinejoin="round" d="M15.91 11.672a.375.375 0 0 1 0 .656l-5.603 3.113a.375.375 0 0 1-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112Z" />
                    </svg>
                    {t.playTetris}
                  </>
                )}
            </Button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-2">
            {recipes.slice(0, displayedRecipes).map((recipe, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-md overflow-hidden cursor-pointer relative"
                onClick={() => {
                  setSelectedRecipe(recipe);
                  setSelectedRecipeIndex(index);
                  setIsDetailDialogOpen(true);
                }}
              >
                {imageData[index] ? (
                  <img
                    src={resolveImageUrl(imageData[index])}
                    alt={recipe.name}
                    className="w-full h-48 object-cover"
                  />
                ) : (
                  <div className="w-full h-48 bg-gray-200 animate-pulse"></div>
                )}
                <div className="p-4">
                  <h3 className="text-lg font-semibold mb-2">{recipe.name}</h3>
                  <div className="flex items-center mb-2">
                    <div className="flex items-center mr-4">
                      <ClockIcon className="h-5 w-5 mr-1 text-blue-500" />
                      <p>{recipe.cooking_time} {t.minutes}</p>
                    </div>
                    {recipe.servings && (
                      <div className="flex items-center mr-4">
                        <UserGroupIcon className="h-5 w-5 mr-1 text-green-500" />
                        <p>{recipe.servings} {t.servings}</p>
                      </div>
                    )}
                    <div className="flex items-center">
                      <FireIcon className="h-5 w-5 mr-1 text-orange-500" />
                      <p>{recipe.calories_per_serving} kcal</p>
                    </div>
                  </div>
                </div>
                <div className="!absolute top-2 right-2 flex gap-1">
                  <IconButton
                    color="black"
                    size="md"
                    variant="outlined"
                    className="bg-white border-none"
                    onClick={(e) => handleDownloadPdf(e, recipe, index)}
                  >
                    <ArrowDownTrayIcon className="h-6 w-6" />
                  </IconButton>
                  <IconButton
                    color="black"
                    size="md"
                    variant="outlined"
                    className="bg-white border-none"
                    onClick={(e) => handleFavorite(e, recipe, index)}
                  >
                    <HeartIcon className="h-6 w-6" />
                  </IconButton>
                </div>
              </div>
            ))}

            {isLoadingMore &&
              Array.from({ length: 4 }).map((_, index) => (
                <div
                  key={`skeleton-${index}`}
                  className="bg-white rounded-lg shadow-md overflow-hidden"
                >
                  <div className="w-full h-48 bg-gray-200 animate-pulse"></div>
                  <div className="p-4">
                    <div className="h-6 bg-gray-200 rounded w-3/4 mb-2 animate-pulse"></div>
                    <div className="h-4 bg-gray-200 rounded w-1/2 mb-2 animate-pulse"></div>
                    <div className="h-4 bg-gray-200 rounded w-1/3 mb-2 animate-pulse"></div>
                  </div>
                </div>
              ))}
          </div>

          <div className="mt-4 mb-8 flex justify-center">
            <Button
              color={isLoadingMore ? 'blue-gray' : 'green'}
              variant='outlined'
              className={` ${isLoadingMore ? 'bg-blue-gray-50' : 'bg-green-50'}`}
              onClick={loadMoreRecipes}
              disabled={isLoadingMore}
            >
              {isLoadingMore ? (
                <div className='flex items-center justify-center font-semibold'>
                  <Spinner className="h-5 w-5 mr-2" /> {t.loading}
                </div>
              ) : (
                t.loadMore
              )}
            </Button>
          </div>
        </>
      )}

      {/* Tetris weergave */}
      {recipesReady && showTetris && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-4 m-2 rounded-lg flex flex-col items-center max-w-4xl w-full">
            <div className="flex justify-between w-full flex-col">
              {recipesReady && (
                <div className="mt-2 mb-2 flex justify-center">
                  <Button
                    variant='outlined'
                    size='sm'
                    color={showTetris ? "green" : "blue-gray"}
                    onClick={toggleView}
                    className="bg-green-50 flex items-center gap-2 m-auto"
                  >
                    {showTetris ?
                      (<>
                        {t.viewRecipes}
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
                        </svg>
                      </>)
                      : (
                        <>
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15.91 11.672a.375.375 0 0 1 0 .656l-5.603 3.113a.375.375 0 0 1-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112Z" />
                          </svg>
                          {t.playTetris}
                        </>
                      )}
                  </Button>
                </div>
              )}
              <div className="w-full">
                <TetrisGame t={t} />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* RecipeDetail component */}
      {selectedRecipe && (
        <RecipeDetail
          recipe={selectedRecipe}
          isOpen={isDetailDialogOpen}
          onClose={() => setIsDetailDialogOpen(false)}
          t={t}
          imageData={imageData[selectedRecipeIndex]}
          recipeIndex={selectedRecipeIndex}
        />
      )}

      {/* Alert bij het opslaan van een favoriet */}
      {showAlert && (
        <div className="fixed bottom-4 left-12 right-12 z-50">
          <Alert
            open={showAlert}
            color={alertColor}
            className="max-w-screen-md mx-auto flex justify-between items-center"
            animate={{
              mount: { y: 0 },
              unmount: { y: 100 },
            }}
            action={
              <IconButton
                variant="text"
                color="white"
                size="sm"
                className=""
                onClick={() => setShowAlert(false)}
              >
                <XMarkIcon className="h-6 w-6" />
              </IconButton>
            }
          >
            {alertMessage}
          </Alert>
        </div >
      )}

      {/* Camera functionaliteit */}
      {
        isCameraActive && (
          <div className="fixed inset-0 z-50 bg-black">
            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              videoConstraints={{ facingMode: "environment" }}
              className="h-full w-full object-cover"
            />
            <Typography variant='h2' className="absolute top-8 left-0 right-0 flex justify-center text-center text-white">{t.pictureIngredients}</Typography>
            <div className="absolute bottom-0 left-0 right-0 flex justify-between p-8 bg-gradient-to-b from-transparent via-transparent to-black">
              <IconButton
                color="blue-gray"
                size='lg'
                variant='outlined'
                className="rounded-full"
                onClick={closeCamera}
              >
                <XMarkIcon className="h-8 w-8" />
              </IconButton>
              <IconButton
                color="white"
                variant='outlined'
                size='lg'
                className="rounded-full shadow-lg"
                onClick={capturePhoto}
              >
                <CameraIcon className="h-8 w-8" />
              </IconButton>
            </div>
          </div>
        )
      }

      {/* Image preview dialog */}
      {
        showImagePreview && (
          <Dialog
            open={showImagePreview}
            handler={setShowImagePreview}
            size="xxl"
            className="h-full max-h-screen flex flex-col bg-[#f7f7f7]"
          >
            <DialogHeader className="m-4 flex items-center justify-center">
              <Typography variant='h6' className='text-center'>
                {t.previewImage}
              </Typography>
            </DialogHeader>
            <DialogBody className="h-[65vh] p-0 flex items-center justify-center overflow-hidden m-4">
              <img
                src={capturedImage}
                alt="Preview"
                className="w-full h-full object-contain shadow-md p-2 rounded-md  bg-white "
              />
            </DialogBody>
            <DialogFooter className=' flex justify-between items-center'>
              <Button
                variant="text"
                color="red"
                onClick={handleRejectImage}
                className="flex items-center gap-2"
              >
                <XMarkIcon className="h-5 w-5" />
                {t.retake}
              </Button>
              <Button
                color="green"
                onClick={handleApproveImage}
                className="flex items-center gap-2 bg-green-500 shadow-none rounded-full"
              >
                <CheckIcon className="h-5 w-5" />
                {t.approve}
              </Button>
            </DialogFooter>
          </Dialog>
        )
      }

      {/* Uploading overlay */}
      {
        isUploading && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-4 m-2 rounded-lg flex flex-col items-center max-w-4xl w-full">
              <div className="flex justify-between w-full flex-col">
                <div className='flex flex-col justify-end'>
                  <div className='flex gap-2 items-center'>
                    <Spinner className="h-6 w-6" />
                    <p className="text-lg font-semibold">{t.uploading}</p>
                  </div>
                  <Typography className='flex items-end' variant='small'>{t.loadingTime}</Typography>
                  {!showTetris &&
                    <Typography variant="h6" className="text-center mt-4 text-green-600">
                      {currentMessage.content}
                    </Typography>
                  }
                </div>

                {!showTetris ? (
                  <div>
                    <div className="bg-white p-5 rounded-lg flex flex-col items-center justify-center">
                      <Cooking />
                      <Typography variant='paragraph' className="mt-4 italic text-center">
                        <span className='font-bold'>{t.cookingTip}</span><br />{currentTip}
                      </Typography>
                    </div>
                    {!showTetris && (
                      <>
                        <Button
                          variant='outlined'
                          color="green"
                          onClick={startTetris}
                          className="bg-green-50 flex items-center gap-2 m-auto"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15.91 11.672a.375.375 0 0 1 0 .656l-5.603 3.113a.375.375 0 0 1-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112Z" />
                          </svg>
                          {t.startTetris}
                        </Button>
                        <Typography variant='small' className='text-xs text-center text-blue-gray-500 mt-2'>{t.waitingNotice}</Typography>
                      </>
                    )
                    }
                  </div>
                ) : (
                  (
                    <div className="w-full">
                      <Button
                        variant='outlined'
                        size='md'
                        color="blue-gray"
                        onClick={backToWaitingScreen}
                        className="bg-blue-gray-50 flex items-center gap-2 m-auto mt-2"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
                          <path strokeLinecap="round" strokeLinejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" />
                        </svg>
                        {t.backToWaiting}
                      </Button>
                      <TetrisGame t={t} />
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        )
      }

      {/* Dialog als recepten zijn geladen */}
      {
        showRecipeLoadedDialog && !hasViewedRecipes && (
          <Dialog size="xl" open={showRecipeLoadedDialog} handler={setShowRecipeLoadedDialog}>
            <DialogHeader>
              <Typography variant='h4' className='text-center'>
                {t.recipesLoaded}
              </Typography>
            </DialogHeader>
            <DialogBody>
              {t.stopOrContinueTetris}
            </DialogBody>
            <DialogFooter className='flex gap-2 justify-between'>
              <Button
                size='sm'
                variant="text"
                color="blue-gray"
                onClick={handleContinueTetris}
              >
                {t.continueTetris}
              </Button>
              <Button
                variant=""
                color="green"
                onClick={handleViewRecipes}
                size='sm'
                className='flex justify-center items-center gap-2'>
                {t.viewRecipes}
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
                </svg>
              </Button>
            </DialogFooter>
          </Dialog>
        )
      }
    </div >
  );
};

export default SearchPage;
